import React from "react";
import Hero from "./Hero";
import CTA from "./CTA";
const Layout =()=>{
    return(
        <div className="layout">
            <Hero />
            <CTA />
        </div>
    )
}
export default Layout;